import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Hazrat Bilal </span>
            from <span className="purple"> Swat, Pakistan.</span>
            <br />
            I am currently employed as a Web Developer at <span className="purple"> Suvatutech SMC PVT LTD.</span>
            <br />
            I have completed BS Computer Science at <span className="purple"> University of Swat.</span>
            <br />
            <br />
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
